import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../cards/backgrounds/card-background-view-model';
import { Observable } from 'rxjs';
import { LabelData } from '../../../../../models/print-labels/label-data';

@Injectable()
export abstract class PrintLabelBackgroundViewModel extends CardBackgroundViewModel {
  public override readonly cardData$: Observable<LabelData>;
}
